<template>
    <div class="ServicesPage">
    <is-loader  v-if="isLoading"></is-loader>
        <v-list v-if="!isLoading" transition="fade-transition">
            <v-list-item-group color="primary">
                <v-list-item :to=service.slug  :disabled=!service.enabled v-for="(service, i) in servicesList" :key="i">
                    <v-list-item-icon>
                        <v-avatar>
                            <img width="70" :src="service.iconurl">
                        </v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="service.name"></v-list-item-title>
                        <v-list-item-subtitle v-html="service.short_description"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {mapState} from 'vuex';
import isLoader from '@/components/is-loader.vue'
  //import axios from 'axios';
  export default {

    name: 'ServicesPage',
    components:{
        isLoader
    },
    computed: {
        ...mapState(['servicesList']),
         isLoading: {
            get() {
            return this.$store.isServicesLoading;
            }
        }
    },
   async mounted() {
        this.$store.dispatch('loadServices',this.$i18n.locale)
    },
    created() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

